import React, { useState } from "react";
import { BASE_URL } from "../utils/config";
import {  useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Switch,
    Tooltip
} from "@mui/material";

import Loading from "../components/loading";


const IntervalRecord = ({ RecordData, heading, updaterecord, Email,updateRecordData  }) => {
    const navigate = useNavigate();
    const columns = [
        { id: "S.No", label: "S.No", minWidth: 40 },
        { id: "IndexName", label: "Stock Symbol", minWidth: 110 },
        { id: "currentInterval1", label: "Interval 1", minWidth: 100 },
        { id: "currentInterval2", label: "Interval 2", minWidth: 120 },
        { id: "currentInterval3", label: "Interval 3", minWidth: 90 },
        { id: "currentInterval4", label: "Interval 4", minWidth: 80 },
        { id: "Action", label: "All Interval", minWidth: 70 },
    ];

    const [Record, setRecord] = useState([]);

  
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(25);
    const [filters, setFilters] = useState();
    const [filteredRecord, setfilteredRecord] = useState([]);

    const [successDialog, setSuccessDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

// handle change to page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        let startindex = newPage * rowsPerPage;
        console.log("startindex", startindex);
        let endindex = Math.min(startindex + rowsPerPage, Record.length);
        console.log("endindex", endindex);
        setStartIndex(startindex);
        setEndIndex(endindex);
    };

    // handle change to row in page
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setEndIndex(+event.target.value);
        setStartIndex(0);
        setPage(0);
    };




//  to show left side tool bar

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="p-input-icon-left table-search">
                    <i className="pi pi-search" />
                    <InputText
                        type="search"
                        value={filters}
                        onChange={handleSearch}
                        placeholder="Search..."
                    />
                </span>
            </>
        );
    };








//  handle change live to local toggel column value for  particular record
    const handleToggleChange = (row, intervalKey) => async (event) => {
        const updatedRow = { ...row };
        let value
        // updatedRow[intervalKey] = event.target.checked ? "Live" : "Local";
         if(event.target.checked === true){
            value = 'Live'
         }else{
            value = 'Local'
         }
        console.log(`Toggled ${intervalKey} for row:`, updatedRow, "New value:", updatedRow[intervalKey]);
        const loginuser = JSON.parse(localStorage.getItem('loginData'));
        try {
           await fetch(`${BASE_URL}/telegramAutomate`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${loginuser.token}`
            },
            body: JSON.stringify({
              rowId: row.id, // Assuming each row has a unique ID
              intervalKey: intervalKey,
              newValue: value,
              SingleValue:true
            }),
          }).then((response) => response.json())
          .then((res) => {
          console.log("Status",res);
          if (res.status === 200) {
            console.log('Update successful:', res);
           
          
            updatedRow[intervalKey] = value;
            updateRecordData(updatedRow);
           setSuccessMessage('Record Successfully Updated.')
           setSuccessDialog(true)
           setTimeout(() => {
            setSuccessDialog(false);
            setSuccessMessage('')
           }, 1500);

          } 
          else if(res.status === 403){ 
               
                setErrorMessage('Token Invalid Or Expire Please Login Again.')
                setErrorDialog(true)
                setTimeout(()=>{
                    setErrorDialog(false)
                    setErrorMessage('')
                    localStorage.clear()
                     navigate('/login')
                  },3000) 
                
          }
          else if(res.status === 401){
            setErrorMessage('Token Invalid Or Expire Please Login Again.')
            setErrorDialog(true)
            setTimeout(()=>{
                setErrorDialog(false)
                setErrorMessage('')
                localStorage.clear()
                 navigate('/login')
              },3000) 
          }else{
            setErrorMessage(`Error: ${res.message}`)
            setErrorDialog(true)
            setTimeout(()=>{
                setErrorDialog(false)
                setErrorMessage('')
              },2000) 
          }
         }).catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
            setErrorMessage(`Error: ${error.message}`)
            setErrorDialog(true)
            setTimeout(()=>{
                setErrorDialog(false)
                setErrorMessage('')
              },1500) 
          });
    } catch (error) {
    console.error("Error fetching data:", error);
    setErrorMessage(`Error: ${error.message}`)
    setErrorDialog(true)
    setTimeout(()=>{
        setErrorDialog(false)
        setErrorMessage('')
      },1500) 
  }
};
      

//  handle change for live to local for all record
    const handleToggleAllChange = (row, intervalKey) => async(event) => {
        // For now we will just log the changes. You can update the row data here or trigger an API call.
        console.log(`Toggled ${intervalKey} for row:`, row, "New value:", event.target.checked);
        let value
        // updatedRow[intervalKey] = event.target.checked ? "Live" : "Local";
         if(event.target.checked === true){
            value = 'Live'
         }else{
            value = 'Local'
         }
        // You can update the row data in a parent state or call an API to persist the change
        const loginuser = JSON.parse(localStorage.getItem('loginData'));
        try {
             await fetch(`${BASE_URL}/telegramAutomate`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loginuser.token}`
              },
              body: JSON.stringify({
                rowId: row.id, // Assuming each row has a unique ID
                intervalKey: intervalKey,
                newValue: value,
                SingleValue:false
              }),
            }).then((response) => response.json())
            .then((res) => {
        
            if (res.status === 200) {
              console.log('Update successful:', res);
             
              updaterecord()
              setSuccessMessage('Record Successfully Updated.')
              setSuccessDialog(true)
              setTimeout(() => {
               setSuccessDialog(false);
               setSuccessMessage('')
              }, 1500);
             
  
            } 
            else if(res.status === 403){ 
                setErrorMessage('Token Invalid Or Expire Please Login Again.')
                setErrorDialog(true)
                setTimeout(()=>{
                    setErrorDialog(false)
                    setErrorMessage('')
                    localStorage.clear()
                     navigate('/login')
                  },3000) 
            }
            else if(res.status === 401){
                setErrorMessage('Token Invalid Or Expire Please Login Again.')
                setErrorDialog(true)
                setTimeout(()=>{
                    setErrorDialog(false)
                    setErrorMessage('')
                    localStorage.clear()
                     navigate('/login')
                  },3000) 
            }
            else{
                setErrorMessage(`Error: ${res.message}`)
                setErrorDialog(true)
                setTimeout(()=>{
                    setErrorDialog(false)
                    setErrorMessage('')
                  },2000) 
              }
          }).catch((error) => {
              console.error("Error fetching data:", error);
              setLoading(false);
              setErrorMessage(`Error: ${error.message}`)
              setErrorDialog(true)
              setTimeout(()=>{
                  setErrorDialog(false)
                  setErrorMessage('')
                },1500) 
            });
      } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage(`Error: ${error.message}`)
    setErrorDialog(true)
    setTimeout(()=>{
        setErrorDialog(false)
        setErrorMessage('')
      },1500) 
    }
    };



//  handle search 
    const handleSearch = (event) => {
        let filetertext = event.target.value;
        setFilters(event.target.value);
        setPage(0);
        setfilteredRecord(
            Record.filter((row) =>
                Object.values(row).some(
                    (value) =>
                        typeof value === "string" &&
                        value.toLowerCase().includes(filetertext.toLowerCase())
                )
            )
        );
    };



 



    return (
        <>
            <Sidebar />
            {loading ? (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                    }}
                >
                    <Loading />
                </div>
            ) : (
                <div >

                    <div className="container-fluid">

                        <Toolbar
                            className="table-pre-head"
                            start={leftToolbarTemplate}
                        ></Toolbar>
                        <div className="table">
                            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                                <TableContainer sx={{ maxHeight: 350 }}>
                                    <Table
                                        style={{ margin: 0 }}
                                        stickyHeader
                                        aria-label="sticky table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column, index) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        title={
                                                            column.id === "last_quantity"
                                                                ? "Last Quantity"
                                                                : column.id === "buy_quantity"
                                                                    ? "Buy Quantity"
                                                                    : column.id === "sell_quantity"
                                                                        ? "Sell Quantity"
                                                                        : column.id === "lower_circuit_limit"
                                                                            ? "Lower Circuit Limit"
                                                                            : column.id === "upper_circuit_limit"
                                                                                ? "Upper Circuit Limit"
                                                                                : ""
                                                        }
                                                        style={{
                                                            textAlign: "center",
                                                            minWidth: column.minWidth,
                                                            backgroundColor: "#23499E",
                                                            color: "white",
                                                            zIndex:
                                                                column.id === "S.No"
                                                                    ? 20
                                                                    : 5,

                                                        }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        {RecordData.length > 0 ? (
                                            <TableBody>
                                                {RecordData
                                                    .slice(startIndex, endIndex)
                                                    .map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row.code}
                                                            >
                                                                {columns.map((column) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            style={{
                                                                                position: "sticky",
                                                                                backgroundColor: "#fff",
                                                                                zIndex:
                                                                                    column.id === "S.No"
                                                                                        ? 10
                                                                                        : 1,

                                                                            }}
                                                                            class="table-cell-screenerTab"
                                                                            key={column.id}
                                                                            align={column.align}
                                                                        >
                                                                            {column.id === "S.No" ? (
                                                                                index + 1
                                                                            ) : column.id === "Action" ? (
                                                                                <div>
                                                                                    <Tooltip title={ row.currentInterval1 === "Live" &&
                                                                                            row.currentInterval2 === "Live" &&
                                                                                            row.currentInterval3 === "Live" &&
                                                                                            row.currentInterval4 === "Live" ? "All Live" : "All Local"} arrow>
                                                                                    <Switch
                                                                                         checked={
                                                                                            row.currentInterval1 === "Live" &&
                                                                                            row.currentInterval2 === "Live" &&
                                                                                            row.currentInterval3 === "Live" &&
                                                                                            row.currentInterval4 === "Live"
                                                                                          }
                                                                                        onChange={handleToggleAllChange(row, "All Change")}
                                                                                        name="intervalSwitch"
                                                                                        color="primary"
                                                                                    />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            ) : column.id === "currentInterval1" ? (

                                                                                <div>
                                                                                    <Tooltip title={row.currentInterval1 === "Live" ? "Live" : "Local"} arrow>
                                                                                    <Switch
                                                                                        checked={row.currentInterval1 === "Live"}
                                                                                        onChange={handleToggleChange(row, "currentInterval1")}
                                                                                        name="intervalSwitch"
                                                                                        color="primary"
                                                                                    />
                                                                                    </Tooltip>
                                                                                </div>

                                                                            ) : column.id === "currentInterval2" ? (
                                                                                <div>
                                                                                       <Tooltip title={row.currentInterval2 === "Live" ? "Live" : "Local"} arrow>
                                                                                    <Switch
                                                                                        checked={row.currentInterval2 === "Live"}
                                                                                        onChange={handleToggleChange(row, "currentInterval2")}
                                                                                        name="intervalSwitch"
                                                                                        color="primary"
                                                                                    />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            ) : column.id === "currentInterval3" ? (
                                                                                <div>
                                                                                    <Tooltip title={row.currentInterval3 === "Live" ? "Live" : "Local"} arrow>
                                                                                    <Switch
                                                                                        checked={row.currentInterval3 === "Live"}
                                                                                        onChange={handleToggleChange(row, "currentInterval3")}
                                                                                        name="intervalSwitch"
                                                                                        color="primary"
                                                                                    />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            ) : column.id === "currentInterval4" ? (
                                                                                <div>
                                                                                    <Tooltip title={row.currentInterval4 === "Live" ? "Live" : "Local"} arrow>
                                                                                    <Switch
                                                                                        checked={row.currentInterval4 === "Live"}
                                                                                        onChange={handleToggleChange(row, "currentInterval4")}
                                                                                        name="intervalSwitch"
                                                                                        color="primary"
                                                                                    />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            ) :
                                                                                (
                                                                                    value
                                                                                )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                            </TableBody>
                                        ) : null}
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75, 100]}
                                    component="div"
                                    count={filteredRecord.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </div>
                    </div>



                    {/*Error Message Dialog */}
                    <Dialog
                        open={errorDialog}
                        onClose={() => { setErrorDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "red" }}>Failure</h4>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                {errorMessage}


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>

                    {/*Success Message Dialog */}
                    <Dialog
                        open={successDialog}
                        onClose={() => { setSuccessDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "green" }}>Success</h4>

                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                <span style={{ color: "black" }}>
                                    {successMessage}
                                </span>


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>









                </div>
            )}
        </>
    );
};

export default IntervalRecord;





